(function () {
  'use strict';

  angular
    .module('app.authentication', [])

    /* @ngInject */
    .controller('authenticationCtrl', ["$scope", "$timeout", "AppService", function ($scope, $timeout, AppService) {
      var ctrl = this;
      ctrl.newClient = {};
      ctrl.templateCreate = '';
      ctrl.createOpen = false;

      ctrl.loadedAccountCreate = function () {
        $scope.$emit('showPageLoader', false);
        $timeout(function () {
          ctrl.createOpen = true;
        });
      };
      ctrl.toggleAccountCreate = function () {
        ctrl.createOpen = !ctrl.createOpen;
      };

      AppService.getTranslate()
        .then(function () {
          ctrl.active = true;
          $timeout(function () {
            ctrl.activeIn = true;
          }, 100);
        });
    }])

    /* @ngInject */
    .controller('loginCtrl', ["$scope", "$rootScope", "$timeout", "$location", "$uibModal", "AccountService", "AppService", "LogService", function ($scope, $rootScope, $timeout, $location, $uibModal, AccountService, AppService, LogService) {

      $timeout(function () {
        $rootScope.$broadcast('showPageLoader', false);
      }, 500);

      $scope.formData = {
        RememberMe: false,
        errors: {}
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {
        $(event.target).find('input').blur();
        $scope.showLoader = true;

        $scope.formData.errors = {};

        if ($scope.returnUrl) {
          $scope.formData.ReturnUrl = $scope.returnUrl;
        }

        LogService.login($scope.formData)
          .then(function (response) {
            if (response.status === 'OK') {
              AppService.getParams(true)
                .then(function (data) {
                  $rootScope.$broadcast('login');
                  if (LogService.redirect) {
                    if (LogService.redirect.action) {
                      LogService.redirect.action(LogService.redirect.url);
                    } else if (LogService.redirect.url) {
                      $location.path(LogService.redirect.url).replace();
                    }
                    LogService.redirect = null;
                  } else {
                    $location.path(AccountService.getLinks().AccountHome).replace();
                  }
                  $scope.showLoader = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            } else if (response.status === 'WaitingForDelegation') {
              // Delegation
              $scope.delegations = response.delegations;
              $scope.showLoader = false;
            } else if (response.status !== undefined) {
              // End Delegation
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                  $scope.showLoader = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            } else {
              location = $scope.returnUrl;
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      $scope.openForgotPassword = function () {
        LogService.email = $scope.formData.Login;
        $uibModal.open({
          templateUrl: '/Template/Authentication/ModalForgotPassword',
          controller: 'forgotPasswordModalCtrl'
        });
      };

    }])

    /* @ngInject */
    .controller('loginModalCtrl', ["data", "device", "options", "$scope", "$rootScope", "$location", "$uibModal", "$uibModalInstance", "$route", "$templateCache", "$window", "AppService", "LogService", "RoutesService", "AccountService", function (data, device, options, $scope, $rootScope, $location, $uibModal, $uibModalInstance, $route, $templateCache, $window, AppService, LogService, RoutesService, AccountService) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      $scope.device = device;

      if (data && data.mailRecognized) {
        setTimeout(function () {
          $('.modal').find('[ng-model="formData.Password"]').focus();
        });
      }

      if (data && data.action) {
        LogService.redirect = {
          url: data.url || null,
          action: data.action
        };
      }

      $scope.linkCreate = '/' + RoutesService.get().Login.url;

      $scope.formData = {
        RememberMe: false,
        errors: {},
        returnUrl: '/'
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {
        $(event.target).find('input').blur();
        $scope.showLoader = true;

        $scope.formData.errors = {};

        LogService.login($scope.formData)
          .then(function (response) {
            if (response.status === 'OK') {
              AppService.getParams(true)
                .then(function () {
                  $rootScope.$broadcast('login');
                  if (LogService.redirect) {
                    if (LogService.redirect.action) {
                      LogService.redirect.action(LogService.redirect.url);
                    } else if (LogService.redirect.url) {
                      $location.path(LogService.redirect.url);
                    }
                    LogService.redirect = null;
                  } else {
                    //$templateCache.remove('/contact?view=Contact');
                    //$route.reload();
                    // Notes : le système de suppression du cache qui a marché à partir du 10 janvier ne fonctionne plus depuis le 23 janvier. Pourtant aucune évolution n'a été apportée, ni au cache angular, ni au routing (hormis un override avec le même nom de route). Hack proposé : recharger la page.
                    $window.location.href = window.location.href;
                  }
                  $scope.showLoader = false;
                  $uibModalInstance.close();
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
            // Delegation
            else if (response.status === 'WaitingForDelegation') {
              $scope.delegations = response.delegations;
              $scope.showLoader = false;
            }
            // End Delegation
            else {
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                  $scope.showLoader = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      $scope.openForgotPassword = function () {
        LogService.email = $scope.formData.Login;
        $uibModalInstance.closed.then(function () {
          $uibModal.open({
            templateUrl: '/Template/Authentication/ModalForgotPassword',
            controller: 'forgotPasswordModalCtrl'
          });
        });
        $uibModalInstance.close();
      };

    }])


    /* @ngInject */
    .controller('loginModalCtrlVentePrivee', ["$scope", "$rootScope", "$location", "$uibModal", "$uibModalInstance", "$route", "AppService", "LogService", "RoutesService", function ($scope, $rootScope, $location, $uibModal, $uibModalInstance, $route, AppService, LogService, RoutesService) {


      //if ($cookies.get('cookiesVP')) {
      //    $cookie.remove('cookiesVP');
      //}

      $scope.linkCreate = '/' + RoutesService.get().Login.url;

      $scope.formData = {
        RememberMe: false,
        errors: {},
        returnUrl: '/'
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {
        $(event.target).find('input').blur();
        $scope.showLoader = true;
        LogService.login($scope.formData)
          .then(function (response) {
            if (response.status === 'OK') {
              $uibModalInstance.close();
              $rootScope.$broadcast('login');
              AppService.getParams(true)
                .then(function (data) {
                  if (LogService.redirect2) {
                    if (LogService.redirect2.url) $location.path(LogService.redirect2.url).replace();
                    if (LogService.redirect2.action) LogService.redirect2.action();
                    LogService.redirect2 = null;
                  } else {
                    $route.reload();
                  }
                })
                .catch(function (error) {
                  console.error(error);
                });
            } else if (response.status === 'WaitingForDelegation') {
              $scope.delegations = response.delegations;
              $scope.showLoader = false;
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
            $scope.showLoader = false;
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      $scope.openForgotPassword = function () {
        LogService.email = $scope.formData.Login;
        $uibModalInstance.closed.then(function () {
          $uibModal.open({
            templateUrl: '/Template/Authentication/ModalForgotPassword',
            controller: 'forgotPasswordModalCtrl'
          });
        });
        $uibModalInstance.close();
      };

    }])

    /* @ngInject */
    .controller('newClientCtrl', ["$scope", "HttpService", "AppService", function ($scope, HttpService, AppService) {

      $scope.formData = {
        errors: {}
      };

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function (event) {

        $(event.target).find('input').blur();
        $scope.$emit('showPageLoader', true);

        $scope.formData.errors = {};

        HttpService.post({
          url: '/TestMailExist',
          data: $scope.authCtrl.newClient
        })
          .then(function (response) {
            if (response.status === 'OK') {
              $scope.showCreate();
            } else {
              $scope.$emit('showPageLoader', false);
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });

      };

      $scope.showCreate = function () {
        if ($scope.authCtrl.templateCreate === '') {
          $scope.$emit('showPageLoader', true);
          $scope.authCtrl.templateCreate = '/AccountCreate';
        } else {
          $scope.$emit('showPageLoader', false);
          $scope.authCtrl.createOpen = true;
        }
      };

    }])

    /* @ngInject */
    .controller('forgotPasswordModalCtrl', ["$scope", "HttpService", "$uibModal", "$uibModalInstance", "AppService", "LogService", function ($scope, HttpService, $uibModal, $uibModalInstance, AppService, LogService) {

      $scope.formData = {
        errors: {}
      };
      $scope.formData.Email = LogService.email;

      $scope.focus = function () {
        $scope.formData.errors.Global = null;
      };

      $scope.submit = function () {

        $scope.showLoader = true;

        $scope.formData.errors = {};

        HttpService.post({
          url: '/ForgotPassword',
          data: $scope.formData
        })
          .then(function (response) {
            if (response.status === 'OK') {
              $uibModalInstance.closed.then(function () {
                $uibModal.open({
                  templateUrl: '/Template/Authentication/ModalForgotPasswordConfirm'
                });
              });
              $uibModalInstance.close();
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      $scope.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
            $scope.showLoader = false;
          })
          .catch(function (error) {
            console.error(error);
          });

      };

    }]);

})();
